import ReactDOM from 'react-dom'
import { Mermaid } from './mermaid'
import { constants } from './mermaid.constant'
import { getMermaids } from './mermaid.selector'

export const ReactMermaidComponent = (() => {
	const parseConfig = (raw: string | null): Record<string, unknown> | undefined => {
		if (raw === null) return undefined
		try {
			// Try to parse JSON; if it fails, ignore and return undefined
			return JSON.parse(raw) as Record<string, unknown>
		} catch (_) {
			// eslint-disable-next-line no-console
			console.warn('Invalid Mermaid data-config JSON; ignoring config')
			return undefined
		}
	}

	const init = (): void => {
		const nodes = getMermaids()
		for (let i = 0; i < nodes.length; i++) {
			const node = nodes[i] as HTMLElement
			const graph = node.getAttribute(constants.selector.graph) || undefined
			const src = node.getAttribute(constants.selector.src) || undefined
			const config = parseConfig(node.getAttribute(constants.selector.config))
			const ariaLabel = node.getAttribute(constants.selector.ariaLabel) || undefined

			ReactDOM.render(
				<Mermaid graph={graph} src={src} config={config} ariaLabel={ariaLabel} className={node.className} />,
				node,
			)
		}
	}

	return {
		init,
	}
})()

export default ReactMermaidComponent
